import React from 'react';
import { Box, Container, VStack, Heading, Text } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const Cookies = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)">
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]}>
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="linear-gradient(135deg, #0053b3 0%, #ef3340 100%)"
          py={{ base: 12, lg: 16 }}
        >
          <Container maxW="1200px" px={5}>
            <Heading as="h1" size={{ base: 'xl', md: '2xl' }} color="white" fontWeight={800} textAlign="center">
              🍪 Politique de cookies
            </Heading>
          </Container>
        </Box>

        <Container maxW="1000px" px={5} py={10}>
          <VStack spacing={8} align="start">
            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>1. Utilisation des cookies</Heading>
              <VStack align="start" spacing={2}>
                <Text>Le site https://rester-en-france.fr utilise des cookies afin de :</Text>
                <VStack align="start" spacing={1} pl={4}>
                  <Text>• Améliorer l’expérience utilisateur</Text>
                  <Text>• Analyser la fréquentation du site</Text>
                  <Text>• Mémoriser vos préférences</Text>
                </VStack>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>2. Types de cookies utilisés</Heading>
              <VStack align="start" spacing={2}>
                <Text>• Cookies nécessaires : garantissent le fonctionnement du site</Text>
                <Text>• Cookies analytiques : permettent d’obtenir des statistiques anonymes (Google Analytics, etc.)</Text>
                <Text>• Cookies de personnalisation : enregistrent vos préférences de navigation</Text>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>3. Gestion des cookies</Heading>
              <VStack align="start" spacing={2}>
                <Text>Lors de votre première visite, un bandeau vous informe de l’utilisation des cookies. Vous pouvez accepter, refuser ou personnaliser vos choix à tout moment via votre navigateur ou en cliquant sur « Gérer mes cookies ».</Text>
                <Text>Pour en savoir plus, consultez la page https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser.</Text>
              </VStack>
            </Box>
          </VStack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default Cookies;
